import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export const Grid = ({ cols, gutter, children }: any) => (_jsx("div", { className: "grid", style: { gridTemplateColumns: `repeat(${cols}, 1fr)`, '--gutter': `${gutter}px` } as React.CSSProperties, children: children }));
export const Span = ({ from, to, children }: any) => (_jsx("div", { className: "span", style: { '--from': from, '--to': to + 1 } as React.CSSProperties, children: children }));
